import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";

export const SentinelDefaultInfoSection = () => (
  <SentinelInfoSection header="Dependency Sentinel">
    <div>
      <p>
        Dependency Sentinel is a platform that will automatically generate code reviews for 
        trivially updatable software. It will scan the software packages and gather a list of 
        dependencies. It will periodically scan for new releases and updated guidance after 
        that it will apply the guidance and produce code reviews where applicable. The 
        development team will be expected to review and merge the code reviews produced as well 
        as conduct end to end integration testing as part of their regular deployment process.
      </p>
    </div>
  </SentinelInfoSection>
);